.skeleton {
  display: flex;
  flex-direction: var(--flex-direction);
  width: var(--width);
  height: var(--height);
}
